// extracted by mini-css-extract-plugin
export default {"toolItem":"tool-item_toolItem__2la07","title":"tool-item_title__DYIr6","description":"tool-item_description__PulMt"};